import find from 'lodash/find';
import {connect} from 'react-redux';

import Details from '../components/details';

import {FEATURE_SOURCE_ALL} from '../config';

export default connect((state, ownProps) => ({
	feature: find(state.featureSources[FEATURE_SOURCE_ALL].data.features, {
		id: ownProps.id,
	}),
	...state.app,
}))(Details);
